import { INVENTORY_RESERVATIONS_DETAILS } from '../actionTypes';

const initialState = {
  content: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INVENTORY_RESERVATIONS_DETAILS.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
